import { render } from "./Price.vue?vue&type=template&id=c623aa20"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c623aa20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c623aa20', __exports__)) {
    api.reload('c623aa20', __exports__)
  }
  
  module.hot.accept("./Price.vue?vue&type=template&id=c623aa20", () => {
    api.rerender('c623aa20', render)
  })

}


export default __exports__